export default __webpack_public_path__ + "static/media/BackIcon.20ac86d3.svg";